import * as React from 'react';

import {colors} from 'shells/colors/colors';

import type {EmailStats as EmailStatsFragment} from 'nutshell-graphql-types';

import {EmailProgressBarLegend} from './email-progress-bar-legend';

import styles from './email-progress-bar.module.css';

const COLOR_SENT = colors.greenDk;
const COLOR_QUEUED = 'rgba(31, 183, 144, 0.5)'; // colors.green with 0.5 opacity
const COLOR_QUEUED_WARNING = colors.yellow;

type Props = {
    stats: EmailStatsFragment;
};

export function EmailProgressBar({stats}: Props) {
    let sentPercentage = stats.emailsSentTodayCount / stats.maxDailyEmailsCount;
    let queuedPercentage = stats.emailsScheduledTodayCount / stats.maxDailyEmailsCount;
    let spacerWidth = 'calc(100% - 19px)'; // 19 is the width of the 0 and half the width of the 300 label
    const queuedColor = stats.status === 'success' ? COLOR_QUEUED : COLOR_QUEUED_WARNING;

    if (sentPercentage + queuedPercentage > 1.0) {
        // More than 100% of emails
        const totalPercentage = sentPercentage + queuedPercentage;
        sentPercentage = sentPercentage / totalPercentage;
        queuedPercentage = queuedPercentage / totalPercentage;

        const spacerPercentage = 1.0 / totalPercentage;
        spacerWidth = `calc(${spacerPercentage * 100}% - 19px)`;
    }

    return (
        <React.Fragment>
            <div className={styles['summary-bar-container']}>
                Today’s outgoing emails
                <div className={styles['summary-bar']}>
                    <div
                        style={{
                            width: `${sentPercentage * 100}%`,
                            backgroundColor: COLOR_SENT,
                            height: '16px',
                        }}
                    />
                    <div
                        style={{
                            width: `${queuedPercentage * 100}%`,
                            backgroundColor: queuedColor,
                            height: '16px',
                        }}
                    />
                </div>
                <div className={styles['summary-bar-label-container']}>
                    <div>0</div>
                    <div style={{width: spacerWidth}} />
                    <div>{stats.maxDailyEmailsCount}</div>
                </div>
            </div>
            <div className={styles['legend-container']}>
                <EmailProgressBarLegend
                    label='sent today'
                    count={stats.emailsSentTodayCount}
                    color={COLOR_SENT}
                />
                {NutCapabilities.emailSequences.isAvailable ? (
                    <EmailProgressBarLegend
                        label='scheduled for today'
                        count={stats.emailsScheduledTodayCount}
                        color={queuedColor}
                    />
                ) : undefined}
            </div>
        </React.Fragment>
    );
}
